import { parse } from 'querystring';

import { injectable } from 'inversify';

@injectable()
export class AppBehavior {
	readonly appView!: boolean;

	constructor() {
		const params = parse(location.search ? location.search.slice(1) : '');
		this.appView = params.isApp === 'true';
	}
}
